import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
    AppNotificationService,
    AppNotificationType,
    ENDPOINTS,
    NotificationDurationModel,
    ODataDurationResponseModel,
    OnlineOnlyService,
} from '@evorait/pace-core';
import { catchError, EMPTY, finalize, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-duration',
    templateUrl: './duration.component.html',
    styleUrls: ['./duration.component.scss'],
})
export class DurationComponent implements OnInit, OnDestroy {
    @Input()
    public model: NotificationDurationModel;
    public durationForm: FormGroup;
    public formChildren: FormArray;
    public durationChangeInProgress = false;

    private destroy$ = new Subject<void>();

    public constructor(
        private readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly onlineOnlyService: OnlineOnlyService,
        private readonly appNotificationService: AppNotificationService,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.durationForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
    }

    public closeModal(): void {
        this.modalInstance.hide();
    }

    public changeDuration(): void {
        this.durationChangeInProgress = true;
        this.onlineOnlyService
            .post<ODataDurationResponseModel>(ENDPOINTS.NotificationDurationChange, this.model.getOutModel())
            .pipe(
                takeUntil(this.destroy$),
                catchError((error) => {
                    this.appNotificationService.setAppNotification(
                        AppNotificationType.ERROR,
                        <string>this.translate.instant('NOTIFICATION_DETAILS_CHANGE_DURATION_ERROR_TITLE'),
                        `${<string>this.translate.instant('NOTIFICATION_DETAILS_CHANGE_DURATION_ERROR_BODY')} ${JSON.stringify(error)}`,
                    );

                    return EMPTY;
                }),
                finalize(() => (this.durationChangeInProgress = false)),
            )
            .subscribe(() => this.closeModal());
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
